import { UUID } from '@/types/types';
import { SerializedModulesManager } from './managers/ModulesManager';
import { SerializedRoomManager } from './managers/RoomManager';
import { Vector2Tuple, Vector3Tuple } from 'three';
import { Asset } from '@/api/AssetApi';
import { SerializedMeasurementManager } from './managers/MeasurementManager';
import { CreatorMeasurement, CreatorOptions } from '@/types/creator';

export enum RendererMode {
	ROOM = 'ROOM',
	MODULES = 'MODULES',
	PREVIEW = 'PREVIEW',
	MEASURING = 'MEASURING',
	CUSTOM_SHAPE_DRAWING = 'CUSTOM_SHAPE_DRAWING',
	COLORING = 'COLORING',
}

export enum UserDataObjectType {
	WALL = 'wall',
	LANDSCAPE_MODULE = 'landscape_module',
	PRODUCT_MODULE = 'product_module',
}

export enum UserDataProp {
	OBJECT_ID = 'object_id',
	OBJECT_TYPE = 'object_type',
	IS_COLORABLE = 'is_colorable',
	TARGET = 'target',
	LEVELS_SHADER = 'levels_shader',
	BAR_TYPE = 'bar_type',
}

export enum BarType {
	HORIZONTAL = 'horizontal',
	VERTICAL = 'vertical',
}

export enum ObjectCustomName {
	ROOM_FLOOR = 'room_floor',
}

export enum ThreeEvent {
	MOUSE_OVER_MODULE = 'mouse_over_module',
	UPDATE_OPTIONS = 'update_options',
	ZOOM_LEVEL = 'zoom_level',
	DISTANCE = 'distance',
	CONTEXT_MENU = 'context_menu',
	SET_MEASUREMENTS = 'set_measurements',
	DETECTED_COLLISION = 'detected_collision',
	MODULES_HISTORY = 'modules_history',
	MODULES_RESTORED = 'modules_restored',
}

export type ThreeEvents = {
	[ThreeEvent.MOUSE_OVER_MODULE]: UUID | null;
	[ThreeEvent.UPDATE_OPTIONS]: Partial<CreatorOptions>;
	[ThreeEvent.ZOOM_LEVEL]: number;
	[ThreeEvent.DISTANCE]: number;
	[ThreeEvent.CONTEXT_MENU]: {
		id: UUID | null;
		position: Vector2Tuple;
		moduleLevel: number;
	};
	[ThreeEvent.SET_MEASUREMENTS]: CreatorMeasurement[];
	[ThreeEvent.DETECTED_COLLISION]: UUID;
	[ThreeEvent.MODULES_HISTORY]: {
		historyLength: number;
		currentHistoryIndex: number;
	};
	[ThreeEvent.MODULES_RESTORED]: SerializedModulesManager;
};

export interface SerializedDraggableObject {
	id: UUID;
	asset: Asset;
	position: Vector3Tuple;
	rotation: number;
}

export type SerializedRenderer = {
	roomManger: SerializedRoomManager;
	modulesManger: SerializedModulesManager;
	measurementManager: SerializedMeasurementManager;
};

export enum CreatorRendererLayer {
	FLOOR = 0,
	ROOM_WALL = 1,
	ROOM_WALL_LABEL = 2,
	ROOM_WALL_LINES = 2,
	ROOM_VERTEX = 3,
	LANDSCAPE_MODULE = 4,
	PRODUCT_MODULE = 5,
	MEASUREMENT = 6,
	DRAWING_VERTEX = 7,
	GRID_HELPER = 31,
}

export interface RectangleResult {
	width: number;
	height: number;
	area: number;
	ratio: number;
}
